import { useFlag } from '@/features/unleash';
import { Box, Heading } from '@simplywallst/ui-core';

interface Props {
  content: React.ReactNode;
}

const PopularScreens = ({ content }: Props) => {
  const featureFlag = useFlag({ name: 'mono-popular-screeners' });
  const isFeatureEnabled =
    featureFlag.flagsReady &&
    featureFlag.enabled &&
    featureFlag.variant.name === 'variant';

  if (!isFeatureEnabled) {
    return null;
  }

  return (
    <Box
      marginBottom="x2"
      paddingY="x2"
      paddingX="x3"
      borderRadiusLg="x1_5"
      backgroundColor="noir"
    >
      <Heading as="h2" typography="smallStrong">
        Popular Screens
      </Heading>
      {content}
    </Box>
  );
};

export default PopularScreens;
